import React from "react";
import CSSModules from "lib/utils/css-modules";

import { OrderInstallmentDecorator, PaymentProfileInstallmentDecorator } from "lib/decorators/index";
import st from "lib/utils/index";
import InstallmentFormSection from "./InstallmentFormSection";
import styles from "./InstallmentFormSection.less";

function normalizeInstallments(installments, object) {
  const isOrder = object.type === "Order";
  const InstallmentDecorator = isOrder ? OrderInstallmentDecorator : PaymentProfileInstallmentDecorator;
  return installments.map((prevInstallment, i) => {
    const isFirstInstallment = i === 0;
    const isLastInstallment = i === installments.length - 1;
    const nextInstallment = new InstallmentDecorator({
      ...prevInstallment,
      position: i,
    });
    const existingInstallment = object.installments.find((ins) => ins.id === nextInstallment.id);

    if (isLastInstallment) {
      nextInstallment.amount_type = "remaining_amount";
      nextInstallment.amount_or_percentage = null;
    } else if (nextInstallment.amount_type === "remaining_amount") {
      if (isOrder) {
        nextInstallment.amount_or_percentage = {
          value: 0,
          currency: object.product_price_currency,
        };
      } else {
        nextInstallment.amount_or_percentage = {
          value: 0,
          currency: "percentage",
        };
      }
    }

    if (isFirstInstallment && nextInstallment.transfer_type === "online_payment") {
      nextInstallment.confirmation_installment = true;
      nextInstallment.paid_by_type = "x_days_after_previous_installment";
      nextInstallment.paid_by_time_duration = 86400 * 2;
    } else {
      nextInstallment.confirmation_installment = false;
      nextInstallment.paid_after_company_approval = true;
    }

    if (isFirstInstallment && nextInstallment.paid_by_type === "x_days_after_previous_installment") {
      if (nextInstallment.confirmation_installment && nextInstallment.paid_after_company_approval) {
        nextInstallment.paid_by_type = "x_days_after_order_full_approval";
      } else if (nextInstallment.confirmation_installment && !nextInstallment.paid_after_company_approval) {
        nextInstallment.paid_by_type = "x_days_after_order_creation";
      } else {
        nextInstallment.paid_by_type = "x_days_after_order_full_approval";
      }
    }

    if (isOrder) {
      if (nextInstallment.transfer_type === "bank_wire") {
        nextInstallment.account_description =
          existingInstallment &&
          existingInstallment.transfer_type === "bank_wire" &&
          existingInstallment.receiver === nextInstallment.receiver
            ? existingInstallment.account_description
            : nextInstallment.receiver === "agent"
            ? object.agent.bank_wire_account_description
            : object.company.bank_wire_account_description;
      } else {
        nextInstallment.account_description = null;
      }
    }

    return nextInstallment;
  });
}

function focusNextToLastInstallment(installments) {
  return installments.map((ins, i) => {
    const _focus = i === installments.length - 2 ? true : undefined;
    return ins._focus === _focus ? ins : { ...ins, _focus };
  });
}

@CSSModules(styles)
export default class InstallmentsListFormSection extends React.PureComponent {
  handleInstallmentAdd() {
    const { parent, installments, onChange } = this.props;
    const InstallmentDecorator =
      parent.type === "Order" ? OrderInstallmentDecorator : PaymentProfileInstallmentDecorator;
    const newInstallment = InstallmentDecorator.build({
      receiver: "supplier",
      transfer_type: "cash",
      ...(parent.type === "Order"
        ? { amount_type: "exact_amount_per_order", amount: { value: 0, currency: parent.product_price_currency } }
        : { amount_type: "percentage_amount", amount_percentage: 0 }),
      paid_by_type: "on_stock_starts_at",
    });
    let nextInstallments = installments.concat([newInstallment]);
    nextInstallments = normalizeInstallments(nextInstallments, parent);
    nextInstallments = focusNextToLastInstallment(nextInstallments);
    onChange(nextInstallments);
  }

  handleInstallmentChange(nextInstallment) {
    const { parent, installments, onChange } = this.props;
    let nextInstallments = installments.map((i) => (i.uuid === nextInstallment.uuid ? nextInstallment : i));
    nextInstallments = normalizeInstallments(nextInstallments, parent);
    nextInstallments = focusNextToLastInstallment(nextInstallments);
    onChange(nextInstallments);
  }

  handleInstallmentRemove(installment) {
    const { parent, installments, onChange } = this.props;
    let nextInstallments = installments.filter((i) => i.uuid !== installment.uuid);
    nextInstallments = normalizeInstallments(nextInstallments, parent);
    onChange(nextInstallments);
  }

  render() {
    const { parent, payments, installments, parentName, errors, summary, onBlur } = this.props;
    return (
      <div styleName="list">
        {installments.map((installment, index) => (
          <div styleName="list-element" key={installment.uuid}>
            <InstallmentFormSection
              parent={parent}
              payments={payments}
              installment={installment}
              name={`${parentName}[${installment.uuid}]`}
              errors={errors}
              onChange={this.handleInstallmentChange.bind(this)}
              onBlur={onBlur}
              onRemove={this.handleInstallmentRemove.bind(this, installment)}
              installmentIndex={index}
              isFirstInstallment={index === 0}
              isSupplier={index === 0 && installment.receiver === "supplier"}
              isLastInstallment={index === installments.length - 1}
            />
          </div>
        ))}
        <div styleName="list-element-new">
          <a onClick={this.handleInstallmentAdd.bind(this, undefined)} className="ui button basic blue">
            <i className="icon material-icons">add</i>
            {I18n.t("papp.components.InstallmentsListFormSection.add_new")}
          </a>
        </div>
        {!!summary && <div styleName="list-element-summary">{summary}</div>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/lib/components/FormSection/InstallmentsListFormSection.jsx